<template>
    <div class="bulletin-wrapper">
        <div class="insert-left" :key="fresher">
            <DataLoader :is_on="loading" />
            <div class="date-checkbox-wrapper">
                <div class="form-input-wrapper checkbox">
                    <label class="form-label">
                      <span>{{ $t("bulletin_board_page.trajno") }}</span>
                    </label>
                      <input
                        v-model="is_trajno"
                        type="checkbox"
                        class="form-checkbox"
                      />
                </div>
                <div class="simple-date-wrapper" v-show="!is_trajno">
                    <div>
                        <label class="form-label" for="datum-end">
                            <span>{{ $t("bulletin_board_page.endtime") }}</span>
                        </label>
                    </div>
                    <input class="form-input" type="date" id="datum-end" ref="datumEnd" name="datum-end" :disabled="is_trajno"
                        @input="notification.end_date = $event.target.value" v-model="notification.end_date" />
                </div>
            </div>
            <!-- *** OPIS **** -->
            <!-- <form-textarea label="Opis" id="opis" ref="opis" :base="notification.text"></form-textarea> -->
            <label class="form-label">
            <span>{{ $t("bulletin_board_page.description") }}</span>
            </label>
            <ckeditor :editor="editor" v-model="notification.text" :config="editorConfig"></ckeditor>
            <form-files-upload 
                :deleted_items.sync="notification.deleted_privici"
                :existing_items.sync="notification.privici"
                :new_items.sync="temp_privici"
                :is_single_upload="true"
                :title="$t('bulletin_board_page.attachment')"
                :btn_title="$t('bulletin_board_page.add_attach')"
            />
            <InvalidElementsList v-if="error_list.length != 0" :error_list="error_list"/>

            <div class="oglasna-save-buttons-wrapper">
                <div class="admin-izmjeni-button" @click="createNewNotification()">
                    <span class="changes-text">{{is_edit_mode ? $t("bulletin_board_page.edit_post") : $t("bulletin_board_page.save_post")  }}</span>
                    <svg class="changes-svg-save" xmlns="http://www.w3.org/2000/svg" width="16" height="15"
                        viewBox="0 0 16 15" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M0.34118 2.19415C0.487647 0.943173 1.54867 0 2.8095 0H12.2983C12.4591 0 12.6145 0.0584645 12.7354 0.164484L15.1736 2.30312C15.7218 2.78392 16.0246 3.48537 15.9984 4.21361L15.6946 12.6607C15.6476 13.966 14.5747 15 13.2671 15H2.65873C1.4843 15 0.492793 14.1283 0.343656 12.9646C-0.0948898 9.54261 -0.113781 6.07999 0.287401 2.65348L0.34118 2.19415ZM2.8095 1.32353C2.22087 1.32353 1.72551 1.76386 1.65713 2.3479L1.60335 2.80723C1.21469 6.1268 1.23299 9.48134 1.65785 12.7965C1.72233 13.2996 2.15098 13.6765 2.65873 13.6765H3.22146V9.92647C3.22146 9.07368 3.91351 8.38235 4.76719 8.38235H10.9501C11.8038 8.38235 12.4959 9.07368 12.4959 9.92647V13.6765H13.2671C13.8615 13.6765 14.3492 13.2065 14.3705 12.6131L14.6744 4.16609C14.6863 3.83507 14.5486 3.51623 14.2995 3.29768L12.0542 1.32838V3.39704C12.0542 4.24983 11.3622 4.94115 10.5085 4.94115H5.20883C4.35515 4.94115 3.66309 4.24983 3.66309 3.39704V1.32353H2.8095ZM4.98801 1.32353V3.39704C4.98801 3.51886 5.08688 3.61763 5.20883 3.61763H10.5085C10.6305 3.61763 10.7293 3.51886 10.7293 3.39704V1.32353H4.98801ZM11.171 13.6765H4.54637V9.92647C4.54637 9.80464 4.64524 9.70588 4.76719 9.70588H10.9501C11.0721 9.70588 11.171 9.80464 11.171 9.92647V13.6765Z"
                            fill="#2D22A4" />
                    </svg>
                    <svg class="changes-svg-saved" style="margin-top: 0.3rem;display: none;"
                        xmlns="http://www.w3.org/2000/svg" width="15" height="10" viewBox="0 0 15 10" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M14.7364 0.258435C15.0879 0.603016 15.0879 1.16169 14.7364 1.50627L6.3364 9.74157C5.98492 10.0861 5.41508 10.0861 5.0636 9.74157L0.263604 5.03568C-0.087868 4.6911 -0.087868 4.13243 0.263604 3.78785C0.615076 3.44327 1.18492 3.44327 1.5364 3.78785L5.7 7.86981L13.4636 0.258435C13.8151 -0.0861451 14.3849 -0.0861451 14.7364 0.258435Z"
                            fill="#05CAB0" />
                    </svg>
                </div>
                <div v-if="is_edit_mode" @click="resetNotification()" class="edit-info add-button add-pen reset-info">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                        <path d="M2.16953 7.695L8.10253 1.762L11.2365 4.897L5.30453 10.83L2.16953 7.695ZM12.8255 3.309L11.8075 4.327L8.67153 1.174L9.68953 0.156003L9.70553 0.140003C9.81448 0.0355403 9.96042 -0.0214415 10.1113 -0.018442C10.2622 -0.0154425 10.4058 0.0472934 10.5105 0.156003L12.8255 2.504C13.0555 2.718 13.0555 3.079 12.8255 3.309V3.309ZM4.63253 11.289L1.15253 12.602C1.04925 12.6426 0.93637 12.6522 0.827736 12.6295C0.719102 12.6069 0.619439 12.553 0.540973 12.4746C0.462507 12.3961 0.408651 12.2964 0.386012 12.1878C0.363373 12.0792 0.372936 11.9663 0.413528 11.863L1.70953 8.382L4.63253 11.289Z" fill="#7B7B8A"/>
                        <path d="M2 2L11 11" stroke="#7B7B8A" stroke-width="3" stroke-linecap="round"/>
                    </svg>
                </div>
            </div>
        </div>
        <div class="insert-right">
            <div class="main-title">{{ $t("bulletin_board_page.posted") }}</div>

            <div class="predmeti-zadaci-box oglasna" v-for="(bul,key) in bulletin_array" :key="key">
                <div class="oglasna-row">

                    <div :style="notification.uid != null && bul.uid != notification.uid ? 'opacity:0.5;' : 'opacity:1'" class="row-wrapp">

                        <div v-html="bul.text" class="oglasna-text">
                        </div>
                        <div class="posted">{{ $t("bulletin_board_page.posted_by") }} {{bul.odvjetnik_bulletin_board_created_byToodvjetnik.ime}} {{bul.odvjetnik_bulletin_board_created_byToodvjetnik.prezime}}
                            ({{convertDate(bul.created_date)}})</div>
                        <div v-if="bul.odvjetnik_bulletin_board_edited_byToodvjetnik != undefined" class="posted">
                            {{ $t("bulletin_board_page.edited_by") }}:
                            {{ bul.odvjetnik_bulletin_board_edited_byToodvjetnik.ime }} {{bul.odvjetnik_bulletin_board_edited_byToodvjetnik.prezime}}
                            </div>
                        <div :style="checkIfPassed(bul.end_date) ? `color:#cc0033`:''" class="posted">{{ $t("bulletin_board_page.due_date") }}{{convertDate(bul.end_date)}}</div>
                    </div>
                    <div class="bulletin-attachments-wrapper">
                        <div :title="attachment.name" @click="getAttachment(attachment.id, attachment.name)" class="bulletin-attachment" v-for="(attachment,key) in bul.attachments" :key="key">
                            <img class="bulletin-attachment-img" :src="returnFileType(attachment.name)" />
                            <div class="bulletin-attachment-name">{{attachment.name.length > 35 ? `${attachment.name.slice(0,35)}...`: attachment.name}}</div>
                        </div>
                    </div>
                    <div v-if="notification.uid == null" class="oglasna-buttons-wrapper">
                        <div @click="setEdit(bul)" class="edit-info add-button add-pen"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><g><g><path fill="#7b7b8a" d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"></path></g></g></svg></div>
                        <div @click="deleteOpen(key)" class="delete-info add-button add-pen"><svg width="11" height="11" viewBox="0 0 11 11"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M9.29826 2.40299C9.47656 2.40299 9.625 2.55103 9.625 2.7394V2.91356C9.625 3.09735 9.47656 3.24998 9.29826 3.24998H1.70218C1.52344 3.24998 1.375 3.09735 1.375 2.91356V2.7394C1.375 2.55103 1.52344 2.40299 1.70218 2.40299H3.03855C3.31001 2.40299 3.54626 2.21003 3.60733 1.93778L3.67732 1.6252C3.78608 1.19941 4.14402 0.916626 4.55367 0.916626H6.44633C6.85152 0.916626 7.21348 1.19941 7.31823 1.60274L7.39311 1.93732C7.45374 2.21003 7.68999 2.40299 7.96189 2.40299H9.29826ZM8.61934 8.76972C8.75886 7.46944 9.00313 4.38031 9.00313 4.34914C9.01205 4.25473 8.98129 4.16535 8.92022 4.09339C8.85469 4.02602 8.77178 3.98615 8.6804 3.98615H2.32307C2.23125 3.98615 2.14388 4.02602 2.08326 4.09339C2.02174 4.16535 1.99143 4.25473 1.99589 4.34914C1.99671 4.35487 2.00547 4.46368 2.02013 4.6456C2.08523 5.45376 2.26654 7.70462 2.38369 8.76972C2.4666 9.55438 2.98145 10.0475 3.7272 10.0654C4.30266 10.0787 4.89551 10.0833 5.50174 10.0833C6.07275 10.0833 6.65267 10.0787 7.24597 10.0654C8.01757 10.0521 8.53197 9.56767 8.61934 8.76972Z"
                                    fill="#70707E" />
                            </svg>
                        </div>
                    </div>
                    <div v-if="notification.uid != null && bul.uid == notification.uid" class="oglasna-buttons-wrapper">
                        <div @click="resetNotification()" class="edit-info add-button add-pen reset-info">
                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                                <path d="M2.16953 7.695L8.10253 1.762L11.2365 4.897L5.30453 10.83L2.16953 7.695ZM12.8255 3.309L11.8075 4.327L8.67153 1.174L9.68953 0.156003L9.70553 0.140003C9.81448 0.0355403 9.96042 -0.0214415 10.1113 -0.018442C10.2622 -0.0154425 10.4058 0.0472934 10.5105 0.156003L12.8255 2.504C13.0555 2.718 13.0555 3.079 12.8255 3.309V3.309ZM4.63253 11.289L1.15253 12.602C1.04925 12.6426 0.93637 12.6522 0.827736 12.6295C0.719102 12.6069 0.619439 12.553 0.540973 12.4746C0.462507 12.3961 0.408651 12.2964 0.386012 12.1878C0.363373 12.0792 0.372936 11.9663 0.413528 11.863L1.70953 8.382L4.63253 11.289Z" fill="#7B7B8A"/>
                                <path d="M2 2L11 11" stroke="#7B7B8A" stroke-width="3" stroke-linecap="round"/>
                            </svg>
                        </div>
                    </div>
                </div>


            </div>
        </div>

        <v-dialog v-model="delete_dialog" width="564px">
            <v-card color="universal-vcard">
                <div class="universal-vdialog-title">
                    {{ $t("bulletin_board_page.popup.title") }}
                </div>
                <div class="vdialog-buttons-wrapper wrapper-three-buttons">
                    <div class="universal-vdialog-button vbutton-secondary" @click="delete_dialog = false"> {{ $t("repetitive.cancel") }}
                    </div>
                    <div class="universal-vdialog-button vbutton-primary" @click="deleteBulletin()"> {{ $t("bulletin_board_page.popup.delete") }} </div>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>
  
<script>
import formInput from "@/components/formElements/formInput.vue";
import formTextarea from "@/components/formElements/formTextarea.vue";
import formDropDown from "@/components/formElements/formDropDown.vue";
import formAutocomplete from "@/components/formElements/formInputAutocomplete.vue";
import adresaElement from "@/components/formElements/adresaElement.vue";
import formAutocompleteSingle from "@/components/formElements/formAutocompleteSingle.vue";
import formInputMultiple from "@/components/formElements/formInputMultiple.vue";
import InvalidElementsList from "@/components/generalComponents/InvalidElementsList.vue";
import auth from '@/services/auth'
import moment from "moment";
import admin from "@/apiCallers/promise_handler_db/admin.js"
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@/plugins/ckeditor_build';
import DataLoader from '@/components/generalComponents/DataLoader'
import { attach } from "engine.io";
import FormFilesUpload from '@/components/formElements/formFilesUpload.vue';


export default {
    data() {
        return {
            editor: ClassicEditor,
            editorData: '<p></p>',
            editorConfig: {
                toolbar: {
                    items: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'link',
                        '|',
                        'undo',
                        'redo',
                        '|',
                        'bulletedList', 
                        'numberedList',
                        'texttransform'
                    ]
                },
                link: {
                    // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
                    addTargetToExternalLinks: true,
                }
            },
            delete_dialog: false,
            refresh_key: 1,
            error_list :[],
            selected_delete: null,
            fresher: 1,
            notification: {
                text: "",
                end_date: moment().add(1, "M").format("YYYY-MM-DD"),
                uid:null,
                deleted_privici:[],
                privici:[]
            },
            snackbar: false,
            snackTimeout: 4000,
            snackText:'',
            temp_privici:[],
            bulletin_array: [],
            is_edit_mode:false,
            is_hovering:false,
            loading:false,
            is_trajno:false,
        };
    },
    async created() {
        this.accessToken = this.$store.state.aToken 
        await admin.getBulletinBoard().then((resp) => {
            this.bulletin_array = resp.data
        })
    },
    methods: {
        checkIfPassed(date) {
            return moment(Date.now()).isAfter(moment(date));
        },
        drop(event) {
            event.preventDefault();
            this.$refs.file.files = event.dataTransfer.files;
            // this.$refs.file.files = this.$refs.file.files[0]
            this.is_hovering=false;
            this.onChange(); // Trigger the onChange event manually
        }, 
        resetNotification(){
            this.notification = {
                text: "",
                end_date: moment().add(1, "M").format("YYYY-MM-DD"),
                uid:null,
                deleted_privici:[],
                privici:[],
            }
            this.is_edit_mode=false;
            this.temp_privici=[];
            this.is_trajno=false;
        },
        setEdit(bullet){
            this.is_edit_mode=true;
            this.notification.text=bullet.text;
            this.notification.end_date=moment(bullet.end_date).format("YYYY-MM-DD");
            this.notification.uid=bullet.uid;
            this.notification.privici=bullet.attachments;
        },
        deleteOpen(key) {
            this.selected_delete = key;
            this.delete_dialog = true;
        },
        verifyObject()
        {
            let is_verified = true;
            if (this.is_trajno) {
                this.notification.end_date=undefined;
            }
            if(this.notification.text == "")
            {
                is_verified = false;
                this.error_list = [ this.$t("bulletin_board_page.error_msg") ];
            }else{
               this.display_err_msg = false;
               this.error_list = [];
            }
            return is_verified;
        },  
        async createNewNotification() {
            const formData = new FormData();
            
            if (this.verifyObject()) {
                this.loading = true;
                for (let i = 0; i < this.temp_privici.length; i++) {
                    formData.append("files", this.temp_privici[i]);
                }
                if (this.is_edit_mode && this.temp_privici.length > 0 && this.notification.privici.length > 0) {
                    this.notification.deleted_privici = [...this.notification.privici];
                    this.notification.privici = [];
                }
                formData.append("notification",JSON.stringify(this.notification))
                formData.append("token", this.accessToken)
                formData.append("person_uid", this.$store.state.logged_in_user.uid);
                
                if(!this.is_edit_mode){
                    await admin.createBulletinNotification(formData).then((resp) => {
                        this.bulletin_array.unshift(resp.data);
                        this.resetNotification();
                        this.fresher++;
                    })
                    .finally(()=>{
                        this.loading = false;
                    })
                }
                else{
                    await admin.editBulletinNotification(formData).then((resp) => {
                        let ind = this.bulletin_array.findIndex((obj)=>obj.uid == resp.data.uid)
                        if (ind >= 0) {
                            this.bulletin_array[ind] = resp.data;
                        }
                        this.resetNotification();
                        this.fresher++;
                    })
                    .finally(()=>{
                        this.loading = false;
                    })
                }
            }
        },
        convertDate(dt) {
            return dt == null ? this.$t("bulletin_board_page.trajno_lasts") : moment(dt).format("DD.MM.YYYY.")
        },
        async deleteBulletin() {
            this.loading = true;
            await admin.deleteBulletinNotification(this.bulletin_array[this.selected_delete].uid, this.bulletin_array[this.selected_delete].attachments, this.accessToken).then((resp) => {
                this.bulletin_array.splice(this.selected_delete, 1);
                this.selected_delete = null;
                this.delete_dialog = false;
            })
            .finally(()=>{
                this.loading = false;
            })
        },
        async getAttachment(attach_id, file_name) {
            this.accessToken = this.$store.state.aToken 
            await admin.getOglasnaAttachent(this.accessToken, attach_id).then((resp) => {
                //pripremanje download linka
                var link = document.createElement("a");
                link.setAttribute("href", resp.data.webUrl);
                link.setAttribute("target", "_blank");
                link.setAttribute("download", file_name);
                link.click();
            })
        },
        returnFileType(file_name) {
            var idx_ext = file_name.split(".").length - 1;
            var extension = file_name.split(".")[idx_ext].toLowerCase();

            var return_val = require("@/assets/img/doc_icon.svg");
            switch (extension) {
                case "docx":
                return_val = require("@/assets/img/doc_icon.svg");
                break;
                case "dotx":
                return_val = require("@/assets/img/doc_icon.svg");
                break;
                case "dotm":
                return_val = require("@/assets/img/doc_icon.svg");
                break;
                case "pptx":
                return_val = require("@/assets/img/ppt-icon.png");
                break;
                case "ppt":
                return_val = require("@/assets/img/ppt-icon.png");
                break;
                case "doc":
                return_val = require("@/assets/img/doc_icon.svg");
                break;
                case "pdf":
                return_val = require("@/assets/img/pdf_icon.svg");
                break;
                case "csv":
                return_val = require("@/assets/img/xls_icon.svg");
                break;
                case "xlsx":
                return_val = require("@/assets/img/xls_icon.svg");
                break;
                case "jpg":
                return_val = require("@/assets/img/jpg_icon.svg");
                break;
                case "jpeg":
                return_val = require("@/assets/img/jpg_icon.svg");
                break;
                case "png":
                return_val = require("@/assets/img/png_icon.svg");
                break;
                case "folder":
                return_val = require("@/assets/img/folder_yellow.svg");
                break;
                default:
                return_val = require("@/assets/img/dat_icon.svg");
                break;
            }
            return return_val;
        },

    },
    mounted() {
        this.$store.state.paginacija.title = this.$t("breadcrumbs.notif_mgmt");
        this.notification.end_date = this.$refs.datumEnd.value;
    },

    props: ["invalid_elements"],
    components: {
        InvalidElementsList,
        "form-input": formInput,
        "form-textarea": formTextarea,
        "form-drop-down": formDropDown,
        "form-autocomplete": formAutocomplete,
        "adresa-element": adresaElement,
        "form-autocomplete-single": formAutocompleteSingle,
        "form-input-multiple": formInputMultiple,
        ckeditor: CKEditor.component,
        DataLoader,
        FormFilesUpload,
    },
};
</script>
  